


























import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { ClassStudent } from '@/models/student/check-student-differences-result';

@Component({ name: 'GStudentImportStudentListModal' })
export default class GStudentImportStudentListModal extends Vue {
  show: boolean = false;

  @Prop() value: boolean;
  @Prop({ default: 0 }) grade: number;
  @Prop({ default: '' }) className: string;
  @Prop({ default: (): ClassStudent[] => [] }) students: ClassStudent[];

  @Watch('value')
  onValueChange(v: boolean) {
    this.show = v;
  }

  @Watch('show')
  onShowChange(v: boolean) {
    this.$emit('input', v);
  }

  get columns(): object[] {
    return [
      {
        title: '出席番号',
        key: 'manageNumber',
        width: 90,
        align: 'center',
        // 登録ファイルに出席番号が入っていない場合は空白表示
        render: (h: any, { row }: any): any =>
          h(
            'span',
            { style: { display: 'block', textAlign: 'right' } },
            row.manageNumber !== null && row.manageNumber !== undefined ? String(row.manageNumber) : '',
          ),
      },
      {
        title: '氏名',
        width: 140,
        align: 'center',
        render: (h: any, { row }: any): any =>
          h('span', { style: { display: 'block', textAlign: 'left', fontWeight: 'bold' } }, `${row.lastName} ${row.firstName}`),
      },
      {
        title: 'フリガナ',
        width: 160,
        align: 'center',
        render: (h: any, { row }: any): any =>
          h('span', { style: { display: 'block', textAlign: 'left' } }, `${row.lastNameKana} ${row.firstNameKana}`),
      },
      {
        title: '登録状況',
        align: 'center',
        render: (h: any, { row }: any): any => {
          if (row.isNew) {
            return h('span', { style: { display: 'block', textAlign: 'left', color: '#1a3a6b', fontWeight: 'bold' } }, '新規');
          }
          const label = row.registeredAt ? `${row.registeredAt}登録` : '登録済';
          return h('span', { style: { display: 'block', textAlign: 'left', color: '#555' } }, label);
        },
      },
    ];
  }

  handleClose() {
    this.show = false;
  }
}
